import type {
    Category,
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import type { AgileOverview } from "@/templates/agile-hub/types";

import type { TemplatePageMetadata } from "./utils/content-queries/get-content-metadata";

interface ILoaderMatcher {
    match: RegExp;
    name: string;
    getPageMetadata?: (props: {
        templates?: Template[];
        collections?: TemplateCollection[];
        categories?: Category[];
        agileOverviews?: AgileOverview[];
        urlSlug?: string;
    }) => TemplatePageMetadata | undefined;
    requireMlTemplateIds?: boolean;
}

export const LoaderMatchers: ILoaderMatcher[] = [
    {
        match: /(agile\/(?<urlSlug>(scrum|kanban|project-management|product-management|agile-at-scale|software-development|design|agile-marketing|advantage|teams|tutorials|agile-conversations)))$/,
        name: "agile-overview-page"
    },
    {
        match: /(?<urlSlug>\/agile\/tutorials\/[a-z0-9-]+)$/,
        name: "agile-tutorial-page"
    },
    {
        match: /(?<urlSlug>\/agile\/[a-z0-9-\/]+)$/,
        name: "agile-article-page"
    },
    {
        match: /templates$/,
        name: "confluence-templates-page"
    },
    {
        match: /templates\/search$/,
        name: "confluence-template-search-page"
    },
    {
        match: /templates\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-details-page",
        getPageMetadata: ({ templates, urlSlug }) => {
            const template = templates?.find(
                (template) => template.urlSlug === urlSlug
            );

            return template
                ? {
                      title: template?.name,
                      description: template?.oneLinerHeadline,
                      titleSuffix: "template"
                  }
                : undefined;
        }
    },
    {
        match: /templates\/collections\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-collection-details-page",
        getPageMetadata: ({ collections, urlSlug }) => {
            const collection = collections?.find(
                (collection) => collection.urlSlug === urlSlug
            );

            return collection
                ? {
                      title: collection?.name,
                      description: collection?.oneLinerHeadline,
                      titleSuffix: "collection"
                  }
                : undefined;
        }
    },
    {
        match: /templates\/categories\/(?<urlSlug>[a-z0-9-]+)$/,
        name: "confluence-template-category-page",
        getPageMetadata: ({ categories, urlSlug }) => {
            // use testCategoriesData for now
            const category = categories?.find(
                (category) => category.urlSlug === urlSlug
            );
            return category
                ? {
                      title: category?.name,
                      description: category?.shortDescriptionOneLiner
                  }
                : undefined;
        }
    },
    {
        match: /customers$/,
        name: "customers-landing-page"
    },
    {
        match: /(customers\/(?<urlSlug>[a-z0-9-]+))$/,
        name: "customers-details"
    }
];
